import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="text-xl text-gray-600">Loading...</div>
    </div>
  );
};

export default LoadingScreen;